import { BaseWidgetEditorComponent } from '@juvare/widget-ui/BaseWidgetEditorComponent';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import React from 'react';
import { buildEventTab, buildGeneralTab, buildHiddenTab, buildStyleTab, buildValidateTab, showWidgetEditDialog } from '../WidgetEditDialog';
import { FormHelperErrorDescription } from '../WidgetForm/Components';
import { defaultWidgetLabelProvider, getLabelAndValuePairs, getVisibleError, handleWidgetUpdate, isSkipValidate, joinLabels, makeNewConfigUnique, renderForm, validateCustom, validateUniqueInList, } from '../WidgetForm/Utils';
import { getFormLabelSuffix } from '../WidgetForm/Utils/getFormLabelSuffix';
import { type } from './types';
import { isEmailValid } from './utils';
const WidgetFormEmail = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const value = (_a = props.internalData.value) !== null && _a !== void 0 ? _a : props.getDataString();
    const error = getVisibleError(props);
    const formLabelSuffix = getFormLabelSuffix(props);
    const elementLabel = formLabelSuffix ? props.config.label + formLabelSuffix : props.config.label;
    const readOnly = props.config.readOnly || ((_b = props.rootParams.formParams) === null || _b === void 0 ? void 0 : _b.readOnly);
    const ariaDescribedBy = React.useId();
    return (React.createElement(FormControl, { fullWidth: true, required: (_c = props.config.validate) === null || _c === void 0 ? void 0 : _c.required, error: !!error, disabled: props.config.disabled },
        React.createElement(InputLabel, { htmlFor: props.id, variant: 'outlined', required: (_d = props.config.validate) === null || _d === void 0 ? void 0 : _d.required, error: !!error, disabled: props.config.disabled }, elementLabel),
        React.createElement(OutlinedInput, { id: props.id, label: elementLabel, fullWidth: true, size: 'medium', type: 'email', required: (_e = props.config.validate) === null || _e === void 0 ? void 0 : _e.required, error: !!error, value: value, disabled: props.config.disabled, readOnly: readOnly, onChange: (event) => {
                if (readOnly) {
                    return;
                }
                const eValue = event.target.value;
                const trimmedValue = eValue.trim();
                if (eValue !== trimmedValue) {
                    props.internalData.value = eValue;
                }
                else {
                    delete props.internalData.value;
                }
                props.setDataString(trimmedValue);
                renderForm(props, { changed: true, autoSaveDebounce: props.config.autoSave });
            }, onBlur: (event) => {
                if (readOnly) {
                    return;
                }
                const eValue = event.target.value;
                const trimmedValue = eValue.trim();
                if (trimmedValue !== eValue) {
                    delete props.internalData.value;
                    props.update();
                    renderForm(props);
                }
            }, inputProps: props.editMode ? { tabIndex: -1 } : undefined, autoFocus: (_f = (!props.editMode && props.config.autoFocus)) !== null && _f !== void 0 ? _f : false, "aria-describedby": ariaDescribedBy }),
        React.createElement(FormHelperErrorDescription, { descriptionId: ariaDescribedBy, error: error, description: props.config.description })));
};
const WidgetFormEmailEditor = (props) => {
    return (React.createElement(BaseWidgetEditorComponent, Object.assign({}, props, { widgetLabelProvider: defaultWidgetLabelProvider, onEditWidget: (endEditing) => showWidgetEditDialog(props, endEditing, { title: 'Email: ' + props.config.label }, buildGeneralTab(props, {
            key: true,
            label: true,
            appendRowIndexToLabel: true,
            disabled: true,
            readOnly: true,
            description: true,
            autoFocus: true,
        }), buildValidateTab(props, { required: true, uniqueInList: true }), buildHiddenTab(props), buildStyleTab(props), buildEventTab(props, { eventOnChange: true, autoSave: true })) }),
        React.createElement(WidgetFormEmail, Object.assign({}, props))));
};
export const widgetFormEmail = {
    type,
    validate: (props) => {
        var _a, _b, _c, _d, _e;
        if (isSkipValidate(props)) {
            return;
        }
        const value = props.getDataStringOrUndefined();
        if (((_a = props.config.validate) === null || _a === void 0 ? void 0 : _a.required) && !value) {
            return (_b = props.config.validate.requiredMessage) !== null && _b !== void 0 ? _b : (props.config.label ? props.config.label + ' is required' : 'Required');
        }
        else if (value && !isEmailValid(value)) {
            return props.config.label ? props.config.label + ' is not valid' : 'Email is not valid';
        }
        if (((_c = props.config.validate) === null || _c === void 0 ? void 0 : _c.uniqueInList) || ((_d = props.config.validate) === null || _d === void 0 ? void 0 : _d.uniqueInGrid)) {
            const error = validateUniqueInList(props, value, props.dataPath);
            if (error) {
                return (_e = props.config.validate.uniqueInListMessage) !== null && _e !== void 0 ? _e : error;
            }
        }
        return validateCustom(props, value);
    },
    update: handleWidgetUpdate,
    getLabelValueAsTextPairs: (props, labelPrefix) => {
        return getLabelAndValuePairs(joinLabels(labelPrefix, props.config.label), props.getDataStringOrUndefined());
    },
    component: WidgetFormEmail,
    icon: React.createElement(AlternateEmailIcon, { fontSize: 'small' }),
    editorComponent: WidgetFormEmailEditor,
    createWidget: (rootConfig, editorPath, widgets) => makeNewConfigUnique(rootConfig, editorPath, widgets, { type, key: 'email', label: 'Email' }),
};
